<template>
  <vxe-grid
    v-bind="gridOptions"
    :data="tableData"
    :columns="tableColumns"
    resizable
  >
    <template v-slot:spec="{ row }">
      {{ row.spec }} {{ row.specUnit }}
    </template>
    <template v-slot:isGroup="{ row }">
      <el-tag size="mini" :type="row.isGroup === 'Y' ? 'light' : 'info'">
        {{ row.v_isGroup }}
      </el-tag>
    </template>
  </vxe-grid>
</template>
<script>
import { request } from '@/api/service'
import tableColumns from './table-columns'
export default {
  props: {
    orderCode: String,
  },
  data() {
    return {
      gridOptions: {
        border: 'full',
        size: 'mini',
        toolbarConfig: {
          zoom: true,
        },
        seqConfig: {},
      },
      tableColumns: tableColumns(this),
      tableData: [],
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.orderCode) return
      request({
        url: '/factory/order/goods/package/size/list',
        method: 'post',
        data: {
          orderCode: this.orderCode,
        },
      }).then((res) => {
        this.tableData = res.body.data
      })
    },
  },
}
</script>
